import { makeAutoObservable, runInAction } from "mobx";  // Assuming your services are in this path
import FileStorageService from "../Services/FileStorageService";

class CanvasImageStore {
  images: { id: number; src: string }[] = [];
  successFiles: { id: number; src: string }[] = [];
  errorFiles: { fileName: string; errorMsg: string }[] = [];
  totalFilesCount: number = 0;
  successCount: number = 0;
  errorCount: number = 0;
  isLoading: boolean = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Function to upload images using the UploadCanvasImages service
  async uploadImages(formData: FormData, IsGallary: boolean) {
    this.isLoading = true;
    this.error = null;
    
    try {
      const result = await FileStorageService.UploadCanvasImages(formData, IsGallary);
      console.log(result +'Uploaded');

      runInAction(() => {
        this.totalFilesCount = result.totalFilesCount;
        this.successCount = result.successCount;
        this.errorCount = result.errorCount;
        this.successFiles = result.successFiles.map((file: { id: string; imageUrl: string }) => ({
          id: Number(file.id),
          src: file.imageUrl,
        }));
        this.errorFiles = result.errorFiles.map((file: { fileName: string; errorMsg: string }) => ({
          fileName: file.fileName,
          errorMsg: file.errorMsg,
        }));
        this.isLoading = false;
      });
      return result;
      
    } catch (error: any) {
      runInAction(() => {
        this.error = error.response?.data.message || "Failed to upload images";
        this.isLoading = false;
      });
    }
  }

  async retrievePhotos(productType: string, sortOption: string, filterOption: string) {
    this.isLoading = true;
    this.error = null;
    try {
      const result = await FileStorageService.RetrievePhotos(productType, sortOption, filterOption);
      runInAction(() => {
        this.images = result.map((image: { id: string; imageUrl: string }) => ({
          id: Number(image.id),
          src: image.imageUrl,
        }));
        this.isLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error = "Failed to load images";
        this.isLoading = false;
      });
    }
  }

  async deleteImage(id: number) {
    this.isLoading = true;
    this.error = null;
    try {
      await FileStorageService.DeleteImages(Number(id));
      runInAction(() => {
        this.images = this.images.filter(image => image.id !== id);
        this.isLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error = "Failed to delete image";
        this.isLoading = false;
      });
    }
  }
}

export const canvasImageStore = new CanvasImageStore();
